import { BlobServiceClient } from '@azure/storage-blob';

export const azureObjectUpload = (file: File, url: string) => {
  return new BlobServiceClient(url).getContainerClient('objects').uploadBlockBlob(file.name, file, file.size);
};
